"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormStore from "Stores/Forms/FormStore";
import InlineForm from "./InlineForm";
import FormEdit from "./FormEdit";
import FormFilter from "./FormFilter";
import FormSettings from "./FormSettings";
import FormReport from "./FormReport";
import { System } from "Constants/objects";
import Portal from '@material-ui/core/Portal';
import { navigateToParent, formSubmit } from "Actions/Forms/FormActions";
import { toolbarTableKeyboardEvents } from "Actions/Table/TableToolBarActions";
import { FormEditContainer } from 'Containers/FormEditContainer'; //НЕ удалять!

var TOOLBAR_HEIGHT = 45;

var styles = function styles(theme) {
  return {
    formHeight: {
      height: "calc(100% - ".concat(TOOLBAR_HEIGHT, "px)")
    }
  };
};

var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = FormStore.getList();
    _this.onFormKeyDown = _this.onFormKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Form, [{
    key: "_onChange",
    value: function _onChange() {
      this.setState(FormStore.getList());
    }
  }, {
    key: "onFormKeyDown",
    value: function onFormKeyDown(e) {
      var _this$state = this.state,
          modals = _this$state.modals,
          fullForm = _this$state.fullForm,
          tables = _this$state.tables;
      var last = FormStore.lastForm();
      var lastFullForm = fullForm.last();

      if (last) {
        if (e.ctrlKey && e.keyCode === 13) {
          //Ctrl+Enter
          formSubmit(last.UUID);
        } else if (e.keyCode === 27) {
          //escape`
          navigateToParent(last.UUID);
        }
      } // Alt+F5, Insert, Enter, Delete


      if (e.keyCode === 116 && e.altKey || e.keyCode === 45 || e.keyCode === 13 || e.keyCode === 46) {
        for (var table in tables) {
          if (tables.hasOwnProperty(table) && tables[table].focused) {
            toolbarTableKeyboardEvents(table, e);
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      FormStore.addChangeListener(this._onChange);
      $(document).on('keydown', this.onFormKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      FormStore.removeChangeListener(this._onChange);
      $(document).off('keydown', this.onFormKeyDown);
      FormStore.destructor();
    }
  }, {
    key: "formFactory",
    value: function formFactory() {
      var _this$state2 = this.state,
          fullForm = _this$state2.fullForm,
          modals = _this$state2.modals;
      var last = fullForm.last();

      if (!last) {
        return null;
      }

      switch (last.type) {
        case System.FORM_TYPE.LIST:
        case System.FORM_TYPE.TREE:
          return React.createElement(InlineForm, {
            UUID: last.UUID,
            formID: last.formID,
            formType: last.type,
            isActive: !modals.size
          });

        case System.FORM_TYPE.EDIT:
        case System.FORM_TYPE.MULTI_EDIT:
          return React.createElement(FormEdit, {
            key: last.UUID,
            additionalData: last.additionalData,
            formObj: last,
            formType: last.type,
            UUID: last.UUID,
            isActive: !modals.size
          });

        case System.FORM_TYPE.MAIN_FORM:
          return null;
      }
    }
  }, {
    key: "modals",
    value: function modals() {
      var _this2 = this;

      var modals = this.state.modals;
      var forms = modals.map(function (formObj, UUID) {
        var form = {};

        switch (formObj.type) {
          case System.FORM_TYPE.EDIT:
          case System.FORM_TYPE.MULTI_EDIT:
            form = React.createElement(FormEdit, {
              key: UUID,
              additionalData: formObj.additionalData,
              formObj: formObj,
              formType: formObj.type,
              UUID: UUID,
              isActive: modals.last().UUID === UUID
            });
            break;

          case System.FORM_TYPE.FILTER_MODAL:
            form = React.createElement(FormFilter, {
              key: UUID,
              additionalData: formObj.additionalData,
              formObj: formObj,
              formType: formObj.type,
              UUID: UUID,
              isActive: modals.last().UUID === UUID
            });
            break;

          case System.FORM_TYPE.SETTINGS_MODAL:
            form = React.createElement(FormSettings, {
              key: UUID,
              formObj: formObj,
              UUID: UUID,
              isActive: modals.last().UUID === UUID
            });
            break;

          case System.FORM_TYPE.REPORT:
            form = React.createElement(FormReport, {
              key: UUID,
              formObj: formObj,
              UUID: UUID,
              isActive: modals.last().UUID === UUID
            });
            break;
        }

        return React.createElement(Portal, {
          key: "p".concat(UUID),
          container: _this2.container
        }, form);
      }).toArray();
      return forms.length ? forms : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var classes = this.props.classes;
      return React.createElement("div", {
        className: classes.formHeight
      }, this.formFactory(), this.modals(), React.createElement("div", {
        ref: function ref(node) {
          _this3.container = node;
        }
      }));
    }
  }]);

  return Form;
}(React.Component);

_defineProperty(Form, "propTypes", {
  classes: PropTypes.object.isRequired
});

export default withStyles(styles)(Form);